import React, { createContext, useContext, useMemo, useState } from 'react';
import { DEFAULT_SORT } from '../utils/sortOptions';

const FiltersContext = createContext(null);

export function FiltersProvider({ children }) {
  const [nameSearchTerm, setNameSearchTerm] = useState('');
  const [oracleTextSearchTerm, setOracleTextSearchTerm] = useState('');
  const [keywordsSearchTerm, setKeywordsSearchTerm] = useState('');
  const [syntaxSearchTerm, setSyntaxSearchTerm] = useState('');
  const [typeSearchTerm, setTypeSearchTerm] = useState('');
  const [setSearchTerm, setSetSearchTerm] = useState('');
  const [selectedColors, setSelectedColors] = useState([]); // W, U, B, R, G, C
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [sourceFilter, setSourceFilter] = useState('all'); // 'all' | 'binder' | 'deck'
  const [sortField, setSortField] = useState(DEFAULT_SORT.sortOption);
  const [sortDirection, setSortDirection] = useState(DEFAULT_SORT.sortDirection);

  const toggleColor = (color) => {
    setSelectedColors(prev => prev.includes(color) ? prev.filter(c => c !== color) : [...prev, color]);
  };

  const toggleType = (type) => {
    setSelectedTypes(prev => prev.includes(type) ? prev.filter(t => t !== type) : [...prev, type]);
  };

  const resetFilters = () => {
    setNameSearchTerm('');
    setOracleTextSearchTerm('');
    setKeywordsSearchTerm('');
    setTypeSearchTerm('');
    setSetSearchTerm('');
    setSyntaxSearchTerm('');
    setSelectedColors([]);
    setSelectedTypes([]);
    setSourceFilter('all');
    setSortField(DEFAULT_SORT.sortOption);
    setSortDirection(DEFAULT_SORT.sortDirection);
  };

  const value = useMemo(() => ({
    nameSearchTerm, setNameSearchTerm,
    oracleTextSearchTerm, setOracleTextSearchTerm,
    keywordsSearchTerm, setKeywordsSearchTerm,
    typeSearchTerm, setTypeSearchTerm,
    setSearchTerm, setSetSearchTerm,
    syntaxSearchTerm, setSyntaxSearchTerm,
    selectedColors, toggleColor,
    selectedTypes, toggleType, setSelectedTypes,
    sourceFilter, setSourceFilter,
    sortField, setSortField,
    sortDirection, setSortDirection,
    resetFilters,
  }), [nameSearchTerm, oracleTextSearchTerm, keywordsSearchTerm, typeSearchTerm, setSearchTerm, syntaxSearchTerm, selectedColors, selectedTypes, sourceFilter, sortField, sortDirection]);

  return <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>;
}

export function useFilters() {
  const ctx = useContext(FiltersContext);
  if (!ctx) throw new Error('useFilters must be used within a FiltersProvider');
  return ctx;
}
